import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { useConstructor } from './use-constructor';

export function useDeleteConstructor() {
  const qc = useQueryClient();
  const { i18n } = useTranslation();

  const {
    methods: { setTrash }
  } = useConstructor();

  const [{ page = 1, ...searchArg }] = useQueryParams({
    page: NumberParam,
    search: StringParam,
    dominant: StringParam,
    startDate: StringParam,
    finishDate: StringParam
  });

  return useMutation(
    async (id?: number) => {
      const { data } = await $api.delete(`/v1/excel-constructor/custom-template/${id}`);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries(['all-constructors', page, searchArg]);

        showMessage(data?.message, data?.accept);

        setTrash({
          visible: false
        });
      }
    }
  );
}
